export const getRoutingRules = (state) => {
    return state.constructs.rrdefs;
}

export const findRrdefsOfSelectedDelegate = (payload) => (state) => {
    
    const { id } = payload;

    const rrdefsOfDelegate = state.constructs.rrdefs.filter(item => item.attributes?.delegate === id)

    const alphabeticallyArrangedList =  rrdefsOfDelegate.sort(function(a,b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    return alphabeticallyArrangedList;
}

export const findRrdefsOfSelectedEvent = payload => (state) => {

    const { event } = payload;

    const rrdefsOfEvent = state.constructs.rrdefs.filter(item => item.attributes?.tcmd === event)
    
    const alphabeticallyArrangedList =  rrdefsOfEvent.sort(function(a,b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })

    return alphabeticallyArrangedList;
}